import { createSlice, PayloadAction, createAction } from "@reduxjs/toolkit";

interface RegistrationState {
  legalStatus: string;
  professionalLicenseNumber: string;
  streetAddress: string;
  city: string;
  postalCode: string;
  stateRegion: string;
  phoneNumber: string;
  countryCode: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyAddress: string;
  companyEmail: string;
  companyPhone: string;
  companyLogo: string | null;
  legalIndividualName: string;
  publicCompanyName: string;
  companyDescription: string;
  website: string;
  onlineContactInfo: { type: string; value: string }[];
  VAT: string;
  TIN: string;
  paymentMethod: string;
  paymentFrequency: string;
  commisionRate: string;
  currency: string;
}

const initialState: RegistrationState = {
  legalStatus: "",
  professionalLicenseNumber: "",
  streetAddress: "",
  city: "",
  postalCode: "",
  stateRegion: "",
  phoneNumber: "",
  countryCode: "+",
  firstName: "",
  lastName: "",
  companyName: "",
  companyAddress: "",
  companyEmail: "",
  companyPhone: "",
  companyLogo: null,
  legalIndividualName: "",
  publicCompanyName: "",
  companyDescription: "",
  website: "",
  onlineContactInfo: [],
  VAT: "",
  TIN: "",
  paymentMethod: "",
  paymentFrequency: "",
  commisionRate: "",
  currency: "",
};

export const registration = createSlice({
  name: "registration",
  initialState,
  reducers: {
    setLegalStatus: (state, action: PayloadAction<string>) => {
      state.legalStatus = action.payload;
    },
    setProfessionalLicenseNumber: (state, action: PayloadAction<string>) => {
      state.professionalLicenseNumber = action.payload;
    },
    setStreetAddress: (state, action: PayloadAction<string>) => {
      state.streetAddress = action.payload;
    },
    setCity: (state, action: PayloadAction<string>) => {
      state.city = action.payload;
    },
    setPostalCode: (state, action: PayloadAction<string>) => {
      state.postalCode = action.payload;
    },
    setStateRegion: (state, action: PayloadAction<string>) => {
      state.stateRegion = action.payload;
    },
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
    setCountryCode: (state, action: PayloadAction<string>) => {
      state.countryCode = action.payload;
    },
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setCompanyName: (state, action: PayloadAction<string>) => {
      state.companyName = action.payload;
    },
    setCompanyAddress: (state, action: PayloadAction<string>) => {
      state.companyAddress = action.payload;
    },
    setCompanyEmail: (state, action: PayloadAction<string>) => {
      state.companyEmail = action.payload;
    },
    setCompanyPhone: (state, action: PayloadAction<string>) => {
      state.companyPhone = action.payload;
    },
    setCompanyLogo: (state, action: PayloadAction<string | null>) => {
      state.companyLogo = action.payload;
    },
    setLegalIndividualName: (state, action: PayloadAction<string>) => {
      state.legalIndividualName = action.payload;
    },
    setPublicCompanyName: (state, action: PayloadAction<string>) => {
      state.publicCompanyName = action.payload;
    },
    setCompanyDescription: (state, action: PayloadAction<string>) => {
      state.companyDescription = action.payload;
    },
    setWebsite: (state, action: PayloadAction<string>) => {
      state.website = action.payload;
    },
    setOnlineContactInfo: (
      state,
      action: PayloadAction<{ type: string; value: string }[]>
    ) => {
      state.onlineContactInfo = action.payload;
    },
    setVAT: (state, action: PayloadAction<string>) => {
      state.VAT = action.payload;
    },
    setTIN: (state, action: PayloadAction<string>) => {
      state.TIN = action.payload;
    },
    setPaymentMethod: (state, action: PayloadAction<string>) => {
      state.paymentMethod = action.payload;
    },
    setPaymentFrequency: (state, action: PayloadAction<string>) => {
      state.paymentFrequency = action.payload;
    },
    setCommisionRate: (state, action: PayloadAction<string>) => {
      state.commisionRate = action.payload;
    },
    setCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },
  },
});

export const {
  setLegalStatus,
  setProfessionalLicenseNumber,
  setStreetAddress,
  setCity,
  setPostalCode,
  setStateRegion,
  setPhoneNumber,
  setCountryCode,
  setFirstName,
  setLastName,
  setCompanyName,
  setCompanyAddress,
  setCompanyEmail,
  setCompanyPhone,
  setCompanyLogo,
  setLegalIndividualName,
  setPublicCompanyName,
  setCompanyDescription,
  setWebsite,
  setOnlineContactInfo,
  setVAT,
  setTIN,
  setPaymentMethod,
  setPaymentFrequency,
  setCommisionRate,
  setCurrency,
} = registration.actions;

export default registration.reducer;
